import {EventEmitter} from 'eventemitter3'
import BiquadCalculator, {FilterType} from './BiquadCalculator'

export default class FilterWizard extends EventEmitter {
  el: HTMLElement

  constructor(selector: string) {
    super()

    this.el = document.querySelector(selector)
    this.populateFilterTypes()

    // Bind to the generate filter button.
    this.el.querySelector('button').addEventListener('click', this.onGenerate.bind(this))
  }

  private populateFilterTypes() {
    // Populate the filter types select box.
    let select = this.el.querySelector('select')
    for (let filterType in FilterType) {
      // Ignore non-numbers.
      if (isNaN(Number(filterType))) {
        continue
      }
      let option = document.createElement('option')
      option.value = filterType
      option.innerHTML = FilterType[filterType]
      select.appendChild(option)
    }
  }

  private onGenerate() {
    let filterType = Number(this.el.querySelector('select').value)
    let Fs = Number(this.el.querySelector('#sample-rate').value)
    let Fc = Number(this.el.querySelector('#fc').value)
    let Q = Number(this.el.querySelector('#q').value)
    let peakGain = Number(this.el.querySelector('#gain').value)

    let tfunc = BiquadCalculator.calculateTransferFunction(filterType, Fc, Fs, Q, peakGain)
    this.emit('transferfunctionchange', tfunc)
  }
}



// WEBPACK FOOTER //
// ./src/FilterWizard.ts